module.exports = __webpack_public_path__ + "static/media/icon_holdperiod.f2824558.svg";